const emptyCartState = {
  cartAvailableBps: [],
  basketAvailabilityStatus: 'idle',
  checkoutSessionUrl: '',
  paymentProcessing: false
}

export default emptyCartState
